import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './css/Navbar.css';
import crownLogo from '../img/crown/ChatGPT Image Dec 11, 2025, 12_53_45 PM.png';


const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.classList.toggle('menu-open', !isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        document.body.classList.remove('menu-open');
    };

    const handleLinkClick = () => {
        closeMenu();
    };

    const isActiveLink = (path: string) => location.pathname === path;

    useEffect(() => {
        closeMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    useEffect(() => {
        return () => {
            document.body.classList.remove('menu-open');
        };
    }, []);

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') closeMenu();
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMenu}>
                    <img
                        src={crownLogo}
                        alt="Crown Residence Logo"
                        className="navbar-logo-image"
                    />
                </Link>

                <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
                    <li className="navbar-item">
                        <Link
                            to="/"
                            className={`navbar-link ${isActiveLink('/') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            НҮҮР
                        </Link>
                    </li>

                    <li className="navbar-item">
                        <Link
                            to="/gallery"
                            className={`navbar-link ${isActiveLink('/gallery') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            А БЛОК
                        </Link>
                    </li>

                    <li className="navbar-item">
                        <Link
                            to="/gallery2"
                            className={`navbar-link ${isActiveLink('/gallery2') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            Б БЛОК
                        </Link>
                    </li>

                    <li className="navbar-item">
                        <Link
                            to="/gallery3"
                            className={`navbar-link ${isActiveLink('/gallery3') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            С БЛОК
                        </Link>
                    </li>

                    <li className="navbar-item">
                        <Link
                            to="/about"
                            className={`navbar-link ${isActiveLink('/about') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            ТӨСЛИЙН ТАЛААР
                        </Link>
                    </li>

                    <li className="navbar-item">
                        <Link
                            to="/contact"
                            className={`navbar-link ${isActiveLink('/contact') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            ХОЛБОО БАРИХ
                        </Link>
                    </li>

                    <li className="navbar-item">
                        <Link
                            to="/partners"
                            className={`navbar-link ${isActiveLink('/partners') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            Хамтрагчид
                        </Link>
                    </li>
                </ul>

                <button
                    className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                    aria-expanded={isMenuOpen}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>
            </div>

        </nav>
    );
};

export default Navbar;
